export default class Zoom {
  constructor() {
    this.$slider = $('.primary-slider');
    this.canvas = '.primary-slider .splide__list > .splide__slide:not(.video)';
    this.$result = $('#img-data-zoom');
  }

  init() {
    this.imageZoomMethod();
  }

  imageZoomMethod() {
    this.imageZoom();
  }

  imageZoom() {
    $(document).on('mousemove touchmove', this.canvas, (e) => {
      const $this = $(e.currentTarget);
      const $childrenImage = $this.find('img');
      this.moveLens(e, $childrenImage);
    });

    this.$slider
      .on('mouseenter', () => {
        this.$result.addClass('hover-in');
      })
      .on('mouseleave', () => {
        this.$result.removeClass('hover-in');
        this.$result.css({ backgroundImage: 'none' });
      });
  }

  moveLens(e, img) {
    e.preventDefault();
    const canvas = document.getElementById('img-data-zoom');
    const pos = this.getCursorPos(e, img);
    const x = pos.x;
    const y = pos.y;

    if (this.$result.css('backgroundImage') === 'none') {
      this.$result.css({ backgroundImage: `url('${img.attr('src')}')` });
    }

    canvas.style.setProperty('--background-x', `-${x}px`);
    canvas.style.setProperty('--background-y', `-${y}px`);
  }

  getCursorPos(e, img) {
    let x = 0;
    let y = 0;
    e = e || window.event;

    const a = img[0].getBoundingClientRect();
    x = e.pageX - a.left;
    y = e.pageY - a.top;
    x = x - window.pageXOffset;
    y = y - window.pageYOffset;

    return { x: x, y: y };
  }
}
